export default __webpack_public_path__ + "static/media/misc-fireplaceA-1024w.3368d4d8.png";